module.exports = __webpack_public_path__ + "media/images/gallery/pn_tab_off-3d966bf6a14183dabe803939cb096c6d.jpg";